export class ProyectosDTO {

}

export class InfoProyectoRequest {
    idProyecto?: number = -1;
    tipoProyecto?: number = -1;
}

export class EmpresasDTO {
    idEmpresaAfiliada: number;
    nombreEmpresaAfiliada: string;
    proyectos: ProyectoDTO[];
}

export class ProyectoDTO {
    idProyecto: number;
    nombreProyecto: string;
    usuarios: UsuarioDTO[];
}

export class UsuarioDTO {
    idUsuario: number;
    nombreUsuario: string;
    login: string;
    tipo: string;
    tipoRegistro: string;
}

export class EmpresaFormat {
    idEmpresaAfiliada: number;
    nombreEmpresaAfiliada: string;
    idProyecto: number;
    nombreProyecto: string;
    idUsuarios: string;
    nombresUsuarios: string;
    logins: string;
    tipos: string;
    tiposRegistro: string;
}

export class ProgresoProyectoInfo {
    progreso?: number = 0;
    cantidadUsuarios: number;
    cantidadMarketing: number;
    cantidadFinanzas: number;
    cantidadVentas: number;
    totalUsuarios: number;
    totalMarketing: number;
    totalFinanzas: number;
    totalVentas: number;

    asignacionUsuario: number = 0;
    modelos: number = 0;
    equipamientosAdicionales: number = 0;
    amenidades: number = 0;
    lotificacion: number = 0;
    brochure: number = 0;
    metasDeMarketing: number = 0;
    inventario: number = 0;
    esquemaFinanciero: number = 0;
    comisiones: number = 0;
    contratosDigitales: number = 0;
    documentos: number = 0;
    equipoVentas: number = 0;
    metasDeVentas: number = 0;
    procesosDeVentas: number = 0;
    encuestas: number = 0;
    configuracionModeloEquipamientos: number = 0;
}

export class Proyecto_Renta_Categoria {
    idCategoria: number;
    nombre: string;
    idUsuarioUM: number;
    fechaHoraUM: string;
    idProyecto: number;
    idEmpresaAfiliada: number;
}
export class Proyecto_Renta_Categoria_Lote {
    idCategoria_Lote: number;
    idProyecto: number;
    idLote: number;
    idUsuarioUM: number;
    fechaHoraUM: string;
}